import React from "react";
import * as BiIcons from "react-icons/bi";
import * as SiIcons from "react-icons/si";
import * as IoIcons from "react-icons/io";
import * as MdIcons from "react-icons/md";
import * as TbIcons from "react-icons/tb";
import * as Io5Icons from "react-icons/io5";
import * as FaIcons from "react-icons/fa6";
import { IoMdClose } from "react-icons/io";

const DynamicIcon = ({ iconName }) => {
  const IconComponent =
    BiIcons[iconName] ||
    SiIcons[iconName] ||
    IoIcons[iconName] ||
    MdIcons[iconName] ||
    Io5Icons[iconName] ||
    FaIcons[iconName] ||
    TbIcons[iconName];

  // If the icon exists, render it; otherwise, render a fallback
  return IconComponent ? (
    <IconComponent />
  ) : (
    <span>
      <IoMdClose />
    </span>
  );
};

export default DynamicIcon;
